'use client';

// FormCheckbox Component with React Hook Form
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';

interface FormCheckboxProps<T extends FieldValues> extends Omit<
  CheckboxProps,
  'name' | 'checked' | 'onChange'
> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  helperText?: string;
}

export const FormCheckbox = <T extends FieldValues>({
  control,
  name,
  label,
  helperText,
  ...props
}: FormCheckboxProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error}>
          <FormControlLabel
            control={
              <Checkbox
                {...props}
                checked={!!field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            }
            label={label}
          />
          {(error?.message || helperText) && (
            <FormHelperText>{error?.message || helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default FormCheckbox;
